import { useMemo } from "react";

import {
  ConfigurationPanel,
  ConfigurationPanelHeader,
  ConfigurationPanelBody,
  ConfigurationPanelFooter,
} from "../../../Components/ConfigurationPanel";
import { Button } from "V2.0/common/button";
import useWhatsappMessageActionForm from "./useWhatsappMessageActionForm";
import WhatsappMessageActionForm from "./WhatsappMessageActionForm";

export default WhatsappMessageAction;

function WhatsappMessageAction(props) {
  const {
    node,
    onSave,
    closePanel,
    assistants,
    workspaceId,
    validationErrors,
    getActiveWhatsappProvider,
    evolutionConfiguration
  } = props;

  const whatsappAssistants = assistants.filter(
    (assistant) => assistant.assistantType === "whatsapp",
  );

  const { formState, updateFormState, errors, validate, setFormState } =
    useWhatsappMessageActionForm(node.data, validationErrors);

  const phoneNumbers = useMemo(() => {
    if (!Boolean(formState.assistantId) || whatsappAssistants.length === 0)
      return [];

    const selectedWhatsappAssistant = whatsappAssistants.find(
      (whatsappAssistant) => whatsappAssistant._id === formState.assistantId,
    );

    if (!selectedWhatsappAssistant) return [];

    return selectedWhatsappAssistant.communicationBinding.map(
      (binding) => binding.identifier,
    );
  }, [whatsappAssistants, formState.assistantId]);

  const phoneNumberOptions = useMemo(() => {
    return phoneNumbers.reduce(
      (acc, phoneNumber, idx) => {
        acc.push({
          id: idx + 1,
          value: phoneNumber,
          label: phoneNumber,
        });
        return acc;
      },
      [{ id: 0, value: "", label: "No PhoneNumber Selected" }],
    );
  }, [phoneNumbers]);

  const whatsappAssistantOptions = useMemo(() => {
    return whatsappAssistants.reduce(
      (acc, whatsappAssistant, idx) => {
        acc.push({
          id: idx + 1,
          label: whatsappAssistant.name,
          value: whatsappAssistant._id,
        });
        return acc;
      },
      [{ id: 0, value: "", label: "No Assistant Selected" }],
    );
  }, [whatsappAssistants]);

  const whatsappProvider = getActiveWhatsappProvider(formState.fromIdentifier);

  const handleSave = () => {
    if (!validate()) return;

    const { data } = node;
    const { phoneNumberField, attributes, template, ...rest } = formState;
    const { templateName, templateLanguage } = JSON.parse(template);

    const updatedData = {
      ...data,
      ...rest,
      templateName,
      templateLanguage,
      inputMapping: {
        phoneNumberField,
        attributesField: attributes,
      },
    };

    onSave(node.id, updatedData);
    closePanel();
  };

  return (
    <ConfigurationPanel>
      <ConfigurationPanelHeader>
        <p>Configure Whatsapp Message</p>
      </ConfigurationPanelHeader>
      <ConfigurationPanelBody>
        <WhatsappMessageActionForm
          errors={errors}
          formState={formState}
          workspaceId={workspaceId}
          setFormState={setFormState}
          updateFormState={updateFormState}
          whatsappProvider={whatsappProvider}
          phoneNumberOptions={phoneNumberOptions}
          assistantOptions={whatsappAssistantOptions}
          evolutionConfiguration={evolutionConfiguration}
        />
      </ConfigurationPanelBody>
      <ConfigurationPanelFooter>
        <div className="flex justify-end items-center gap-x-2">
          <Button
            outline
            onClick={closePanel}
          >
            Cancel
          </Button>
          <Button onClick={handleSave}>Save</Button>
        </div>
      </ConfigurationPanelFooter>
    </ConfigurationPanel>
  );
}
